<template>
    <div>
        <h5 class="mb-4">
            <strong>Gestión de consejos de prudencia</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Nombre o código">
                    <b-form-input v-model="filterTipsPrudenceSga.name" type="text" placeholder="Ingrese nombre o código"
                        @keyup.enter="searchTipPrudenceSga"
                        class="form-control" />
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label="Tipo de consejo">
                    <el-select v-model="filterTipsPrudenceSga.prudence_tip_type_id" clearable filterable size="medium"
                        placeholder="Buscar por tipo de consejo">
                        <el-option v-for="item in activeTypesTipPrudenceSga" :key="item.id" :label="item.name"
                            :value="item.id" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label="Estado">
                    <el-select v-model="filterTipsPrudenceSga.is_active" clearable filterable size="medium"
                        placeholder="Buscar por estado">
                        <el-option v-for="item in statesSga" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchTipPrudenceSga">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <el-tooltip effect="light" placement="top" popper-class="py-1 px-2" content="Sincronizar idiomas">
                        <b-button variant="warning" class="ml-1 mr-1" @click="asyncLanguagesTipsPrudenceSga">
                            <i class="fa fa-language" aria-hidden="true"></i>
                        </b-button>
                    </el-tooltip>
                    <b-button variant="primary" @click="createTipPrudence">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Nuevo consejo de prudencia'" />
                    </b-button>
                </b-form-group>
            </b-col>

            <b-modal id="modal_create_tip_prudence" size="md" hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Registrar nuevo' }} consejo de prudencia
                </template>
                <formTipsPrudence />
            </b-modal>

            <b-col md="12">
                <b-form-group>
                    <b-table :items="tipsPrudenceSga.data" :fields="fields" responsive striped hover bordered
                        thead-tr-class="table-active" show-empty thead-class="table-active"
                        empty-text="No hay resultados para mostrar.">
                        <template #cell(is_active)="data">
                            <b-badge :variant="data.item.is_active ? 'success' : 'danger'"
                                v-text="data.item.is_active ? 'ACTIVO' : 'INACTIVO'" />
                        </template>
                        <template #cell(actions)="data">
                            <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                                <el-tooltip content="Editar" placement="top" effect="light">
                                    <el-button type="text" class="text-primary" @click="editTipPrudence(data.item)">
                                        <i class="fa fa-edit fa-lg"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                    placement="top" effect="light">
                                    <el-button type="text" @click="changeStatus(data.item.id)"
                                        :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`">
                                        <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                    </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filterTipsPrudenceSga.page"
                            :total="filterTipsPrudenceSga.total" :current-page="filterTipsPrudenceSga.page"
                            :page-size="filterTipsPrudenceSga.per_page" @size-change="afterChangeSizePagination"
                            @current-change="afterChangePagePagination" :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>
import { mapActions, mapState, mapMutations, MapActions } from 'vuex';
import formTipsPrudence from './FormTipsPrudence.vue';
export default {
    name: 'tipsPrudence',
    components: {
        formTipsPrudence,
    },
    data() {
        return {
            fields: [
                {
                    key: "code",
                    label: "Código",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "name",
                    label: "Nombre",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "sga_prudence_tip_type.name",
                    label: "Tipo de consejo",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "is_active",
                    label: "Estado",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "user.name",
                    label: "Creado por",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "actions",
                    label: "Acciones",
                    sortable: false,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ],
        };
    },

    computed: {
        ...mapState('sgaTipsPrudence', ['tipsPrudenceSga', 'action', 'filterTipsPrudenceSga']),
        ...mapState('sgaVersions', ['statesSga']),
        ...mapState('sgaTypesTipPrudence', ['activeTypesTipPrudenceSga']),
    },

    async created() {
        await this.getActiveTypesTipPrudenceSga();
    },

    methods: {
        ...mapActions('sgaTipsPrudence', ['getTipsPrudenceSga', 'changeStatusTipPrudenceSga', 'showTipPrudenceSga', 'asyncLanguagesTipsPrudenceSga']),
        ...mapActions('sgaTypesTipPrudence', ['getActiveTypesTipPrudenceSga']),
        ...mapMutations('sgaTipsPrudence', ['setActionTipPrudenceSga', 'setDefaultFilterTipsPrudenceSga', 'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination']),

        createTipPrudence() {
            this.setActionTipPrudenceSga('create');
            this.$bvModal.show('modal_create_tip_prudence');
        },

        async clearFilter() {
            this.setDefaultFilterTipsPrudenceSga();
            await this.getTipsPrudenceSga();
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getTipsPrudenceSga();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getTipsPrudenceSga();
        },

        async changeStatus(id) {
            await this.changeStatusTipPrudenceSga(id);
            await this.getTipsPrudenceSga();
        },

        editTipPrudence(tipPrudence) {
            this.showTipPrudenceSga(tipPrudence.id);
            this.setActionTipPrudenceSga('edit');
            this.$bvModal.show('modal_create_tip_prudence');
        },

        async searchTipPrudenceSga() {
            await this.getTipsPrudenceSga(true);
        },
    },
};
</script>
